//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContentHeader from 'components/ContentHeader'

export default {
  components: {
    ContentHeader
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/pages/PageHome.vue